const $topnav = $('#toTop');

if ($topnav.length > 0) {
  const $toTop = $('#toTop');

  const scrollPosFilters = $('.tabBar').offset();
  const scrollPosFiltersTop = scrollPosFilters.top;

  // back to top
  $(window).scroll(() => {
    const yScrollPos = window.pageYOffset;

    if (yScrollPos > scrollPosFiltersTop) {
      $toTop.fadeIn();
    } else {
      $toTop.fadeOut();
    }
  });

  $toTop.click(() => {
    $('html, body').animate({
      scrollTop: scrollPosFiltersTop,
    }, 1000);
  });
}

const $scrollTop = $('.js-scroll-top');
$scrollTop.click((e) => {
  e.preventDefault();
  $('html, body').animate({
    scrollTop: 0,
  }, 1000);
});
